import { configureStore, type Action } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';
import rootEpics from './epics';
import rootReducers from './reducers';
import type { RootState } from './types';

const storeConfig = (config: any) => {
  const epicMiddleware = createEpicMiddleware<Action, Action, RootState>();

  const store = configureStore({
    reducer: rootReducers,
    middleware: getDefaultMiddleware => {
      const middlewares = getDefaultMiddleware({
        serializableCheck: false,
      }).concat(epicMiddleware);

      return middlewares;
    },
  });

  epicMiddleware.run(rootEpics);

  return { store };
};

export default storeConfig;
